/**
 * Статус промпта
 */
export const enum PromptStatus {
    Moderation = 'moderation',
    Rejected = 'rejected',
    Published = 'published',
    // Unpublished = 'unpublished',
    Postponed = 'postponed',
}

/**
 * Комментарий модерации
 */
export const enum ModerationComment {
    Later = 'later',
}
export type Author = {
    uid?: string;
    login?: string;
    name?: string;
    image?: string;
    promptsCount?: number;
    isPublic?: boolean;
};

/**
 * Структура промпта из JSON файла
 */
export type Prompt = {
    id: number;
    title: string;
    description: string;
    categories: string[];
    categoriesEn: string[];
    prompt: string;
    promptForExample: string;
    example: string;
    exampleImage?: string;
    imageData: {
        urlOptimized: string;
        colors: {
            MainColor: string;
        };
    };
    videoData: {
        url: string;
    };
    likes: number;
    visits: number;
    author: Author;
    createdAt: string;
    isEditorial?: boolean;
    isLiked?: boolean; // Поле из API для статуса лайка
    status?: PromptStatus;
    moderationComment?: ModerationComment; // Комментарий модератора
};

/**
 * Параметры для получения списка промптов с пагинацией
 */
export type PromptsParams = {
    cursor?: string;
    categories?: string[]; // Фильтр по категориям (проверяется вхождение всех в массив categoriesEn)
    limit?: number;
    hash?: string; // Хэш для рандомной, но стабильной сортировки
};

/**
 * Ответ API со списком промптов и курсором
 */
export type PromptsResponse = {
    prompts: Prompt[];
    next_cursor: string | null;
};

/**
 * DTO для создания промпта
 * Используем поля из типа Prompt + author
 */
export type CreatePromptDto = Pick<Prompt, 'title' | 'description' | 'prompt' | 'categories'> & {
    author: string; // Логин автора
};

/**
 * DTO для обновления промпта (оставляем как мок)
 */
export type UpdatePromptDto = {
    title?: string;
    description?: string;
    content?: string;
    category?: string;
    status?: 'draft' | 'published' | 'archived';
};

export const EDITORIAL_UID = '0';
